var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.showContent)?_c('loading'):_vm._e(),_vm._v(" "),_c('h1',{staticClass:"titulo"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"pagina-customizada",domProps:{"innerHTML":_vm._s(_vm.html)}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bcd3c14","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Internas.vue
// module id = null
// module chunks = 